import { makeStyles } from '@material-ui/core/styles';
import { THEME } from 'GlobalStyles';
import { colors } from 'UI/res';

export const useStyles = makeStyles(() => ({
  colorIndicator: {
    borderRadius: '50%',
    border: 'none',
    padding: 0,
    width: ({ size }) => size,
    height: ({ size }) => size,
    backgroundColor: ({ backgroundColor }) => backgroundColor
  }
}));

export const StatusColor = {
  standby: THEME.palette.warning.main,
  inactive: colors.red,
  active: THEME.palette.success.main,
  placement: THEME.palette.customColors.navyBlue,
  sendout: colors.success,
  offline: THEME.palette.status.inactive
};
